module.exports = __webpack_public_path__ + "img/instagram.d1077ea2.svg";